import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Alert, AlertService, AlertType } from '@michelin/theme';
import { PasswordResetService } from 'src/app/shared/services/auth/password-reset.service';

@Component({
    selector: 'app-update-password',
    templateUrl: './update-password.component.html',
    styleUrl: './update-password.component.scss',
    standalone: false
})
export class UpdatePasswordComponent implements OnInit {
  image = true;
  loading = false;
  expired = false;
  passwordChanged = false;
  requestCode: string;
  form: FormGroup;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly passwordResetService: PasswordResetService,
    private readonly alertService: AlertService,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.form = formBuilder.group({
      password: formBuilder.control('', [Validators.required]),
      confirmPassword: formBuilder.control('', [Validators.required])
    });
  }

  updatePassword() {
    const values = this.form.value;
    const password = this.form.value['password'];
    const confirmPassword = this.form.value['confirmPassword'];

    if (password != confirmPassword) {
      return this.alertService.showAlert({
        type: AlertType.strong,
        title: 'As senhas não são iguais.'
      } as Alert);
    }

    this.passwordResetService.changePassword(this.requestCode, password, confirmPassword).subscribe({
      next: () => {
        this.alertService.showAlert({
          type: AlertType.success,
          title: 'Senha atualizada com sucesso!'
        } as Alert);
        this.passwordChanged = true;
      },
      error: () =>
        this.alertService.showAlert({
          type: AlertType.critical,
          title: 'Ocorreu um erro ao processar a solicitação'
        } as Alert)
    });
  }

  ngOnInit() {
    this.requestCode = this.activatedRoute.snapshot.params['requestCode'];
    this.loading = true;
    this.passwordResetService
      .checkRequest(this.requestCode)
      .subscribe({
        next: (response) => (this.expired = response.expired),
        error: () => (this.expired = true)
      })
      .add(() => (this.loading = false));
  }
}
